import React from 'react';
import { GetCompanyTagsType } from 'application/repositories/company/types';

import {
  CompanyTagPureType,
  CompanyTagQueryFilter,
  CompanyTagQueryPagination,
  CompanyTagQueryPaginationType,
  PaginationInfoType,
} from 'domain/api/graphql/generated';

/** useCompanyTagsPaginationPresenter Types */
export type DefaultCompanyTagsFiltersType = {
  companyId: string;
  title?: string;
};

export const COMPANY_TAGS_PAGINATION_DEFAULT_FILTERS: DefaultCompanyTagsFiltersType = {
  companyId: '',
  title: '',
};

export type UseCompanyTagsPaginationPresenterProps = {
  getCompanyTags: (args: GetCompanyTagsType) => Promise<void>;
  getMoreCompanyTags: (args: GetCompanyTagsType) => Promise<void>;
  readCompanyTags: ({ filters, pagination }: GetCompanyTagsType) => CompanyTagQueryPaginationType;
};

export type UseCompanyTagsPaginationPresenter<T = CompanyTagPureType> = {
  companyTags: T[];
  paginationInfo: PaginationInfoType;
  allCompanyTagsCount: number | null;
  filtersRef: React.MutableRefObject<CompanyTagQueryFilter>;
  requestCompanyTags: (filters?: CompanyTagQueryFilter, pagination?: CompanyTagQueryPagination) => Promise<void>;
  loadMoreCompanyTags: () => Promise<void>;
  onFilterExecute: (newFilters: CompanyTagQueryFilter) => Promise<void>;
  resetFilters: () => void;
};
